import { render, staticRenderFns } from "./EditPurchasesPaymentPage.vue?vue&type=template&id=24a02204"
import script from "./EditPurchasesPaymentPage.vue?vue&type=script&lang=js"
export * from "./EditPurchasesPaymentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports